import {
	SUBMIT_ADD_PAYEE_SUCCESS,
	SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS,
} from '../../../payees/states/addPayee/actions';
import { payeeTypes } from '../../../config';

const addPayeeSuccess = (state = {}, action) => {
	if (action.type === SUBMIT_ADD_PAYEE_SUCCESS) {
		return !action.meta.isPaymentFlow && action.payload;
	}
	if (action.type === SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS) {
		return !action.meta.isPaymentFlow && { ...action.payload, type: payeeTypes.INTERNATIONAL };
	}
	return state;
};

export default addPayeeSuccess;
